const SHAPE_OPTIONS_PLANTIO_POLIOGONO_IMPORTACAO = {
	fillColor: '#77F821',
	strokeColor: '#F82027',
	strokeOpacity: 0.6,
	zIndex: 20,
	strokeWeight: 2.0,
	fillOpacity: 0.4,
}

const SHAPE_OPTIONS_PLANTIO_POLIGONO = (properties) => {
	return {
		fillColor: properties.selected ? '#77F821' : properties.blocked ? '#B9BABA' : '#ffffff',
		fillOpacity: properties.selected ? 0.4 : 0.2,
		strokeColor:
			properties.mostraContinuos && properties.selected
				? '#F82027'
				: properties.mostraPreCorte && properties.selected
					? '#20A5F8'
					: properties.selected
						? '#77F821'
						: properties.blocked
							? '#87696a'
							: properties.plantioSemMarcador
								? '#F82027'
								: '#F8E320',
		strokeWeight: 2,
		strokeOpacity: 0.6,
		zIndex: 20,
	}
}

export const SHAPE_OPTIONS_PLANTIO_POLIGONO_ORDEM_SERVICO = (properties) => {
	return {
		fillColor: '#77F821',
		fillOpacity: properties.selected ? 0.4 : 0.2,
		strokeColor:
			properties.mostraContinuos && properties.selected
				? '#F82027'
				: properties.mostraPreCorte && properties.selected
					? '#20A5F8'
					: properties.selected
						? '#77F821'
						: properties.blocked
							? '#87696a'
							: properties.plantioSemMarcador
								? '#F82027'
								: '#F8E320',
		strokeWeight: 2,
		strokeOpacity: 0.6,
		zIndex: 20,
	}
}

export { SHAPE_OPTIONS_PLANTIO_POLIGONO, SHAPE_OPTIONS_PLANTIO_POLIOGONO_IMPORTACAO }
